/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import Document from "./document";
import i18next from "i18next";

import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Menu, Segmented } from "antd";

import RowData from "./row-data";
import SurveyLink from "./survey";
import ExportData from "./export-data";
import iconVietnam from "../assets/icon/vietnam.png";
import FilterComponent from "../dashboard/filter";
import SubgroupFilterBar from "../dashboard/filter/SubgroupFilterBar";
import iconUnitedStates from "../assets/icon/united-states.png";
import UserManager from "./../pages/users/index";
import MonitoringPage from "./../pages/monitoring/index";
import AreaManagementPage from "./../pages/area-management/index";
import DataImportPage from "./../pages/data-import/index";
import HospitalDirectoryPage from "./../pages/hospital-directory/index";

import { sendGet } from "../api/axios";
import { EDepartment } from "../common/const";
import { SCREEN_DEFAULT } from "../common/ngok";
import { storeSetLanguage } from "../store/auth-reducer";
import {
  storeSetDashboardData,
  storeSetTableData,
} from "../store/data-reducer";
import {
  Buttonanguage,
  ContainerWrapper,
  CurrentScreen,
  IConLanguage,
  PathWrapper,
  SelectedLanguage,
} from "./styled";
import Home from "./Home/Home";

const AppContainer = ({ screen, title, setScreen }) => {
  const dispath = useDispatch();
  const location = useLocation();
  const patch = location?.pathname || "/dashboard";
  const [modalData, setModalData] = useState(false);

  const hospitalSelected = useSelector(
    (state) => state?.data?.hospitalSelected
  );

  const [value, setValue] = useState(EDepartment.OBSTETRIC);
  const [isLoading, setIsLoading] = useState(false);

  const getDataDashboard = async (selectedCode) => {
    try {
      setIsLoading(true);
      const response = await sendGet(
        `/dm/data/evaluation?hospital=${selectedCode}`
      );
      if (response[0]) {
        dispath(storeSetDashboardData(response));
      }
    } catch (error) {
      dispath(storeSetDashboardData(null));
    } finally {
      setIsLoading(false);
      getOverView(hospitalSelected?.code);
    }
  };

  const getOverView = async (selectedCode) => {
    try {
      const response = await sendGet(
        `/dm/data/evaluation/overview?hospital=${selectedCode}`
      );
      if (response?.status === "successful") {
        dispath(storeSetTableData(response?.data));
      }
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    if (hospitalSelected) {
      getDataDashboard(hospitalSelected?.code);
      setValue(EDepartment.OBSTETRIC);
    }
  }, [hospitalSelected]);

  return (
    <ContainerWrapper>
      <div className="header">
        <PathComponent screen={screen} setScreen={setScreen} />
        <FilterComponent
          disabled={
            patch === SCREEN_DEFAULT[2] ||
            patch === SCREEN_DEFAULT[4] ||
            patch === SCREEN_DEFAULT[6] ||
            patch === SCREEN_DEFAULT[7] ||
            patch === SCREEN_DEFAULT[8] ||
            patch === SCREEN_DEFAULT[9] ||
            patch === SCREEN_DEFAULT[10] ||
            patch === SCREEN_DEFAULT[11] ||
            patch === SCREEN_DEFAULT[3]
          }
          screen={screen}
          setScreen={setScreen}
          setModalData={setModalData}
        />
        {(patch === SCREEN_DEFAULT[1] || patch === "/") && <SubgroupFilterBar />}
      </div>
      {patch === SCREEN_DEFAULT[1] || patch === "/" ? (
        <Home
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          value={value}
          setValue={setValue}
        />
      ) : (
        <div />
      )}
      {patch === SCREEN_DEFAULT[2] && <SurveyLink />}
      {patch === SCREEN_DEFAULT[3] && <RowData />}
      {patch === SCREEN_DEFAULT[4] && <Document title={title} />}
      {patch === SCREEN_DEFAULT[6] && <ExportData />}
      {patch === SCREEN_DEFAULT[7] && (
        <UserManager modalData={modalData} setModalData={setModalData} />
      )}
      {patch === SCREEN_DEFAULT[8] && <MonitoringPage />}
      {patch === SCREEN_DEFAULT[9] && <AreaManagementPage />}
      {patch === SCREEN_DEFAULT[10] && <DataImportPage />}
      {patch === SCREEN_DEFAULT[11] && <HospitalDirectoryPage />}
    </ContainerWrapper>
  );
};

export default AppContainer;

function PathComponent({ screen, setScreen }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const language = useSelector((state) => state?.auth?.language);
  const setLanguage = (languageChange) => {
    dispatch(storeSetLanguage(languageChange));
  };

  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <div
              onClick={() => {
                i18next.changeLanguage("vi");
                setLanguage("vi");
              }}
            >
              <IConLanguage src={iconVietnam} alt="" /> {t("common.vietNam")}
            </div>
          ),
        },
        {
          key: "2",
          label: (
            <div
              onClick={() => {
                i18next.changeLanguage("en");
                setLanguage("en");
              }}
            >
              <IConLanguage src={iconUnitedStates} alt="" />{" "}
              {t("common.engLish")}
            </div>
          ),
        },
      ]}
    />
  );
  const location = useLocation();

  const patch = location?.pathname || "/dashboard";

  const screenFake = {
    dashboard: t("screen.surveyResults"),
    survey_urls: t("screen.surveyLink"),
    raw_data: t("screen.rowData"),
    documents: t("screen.regulations"),
    exportData: t("screen.exportReport"),
    user_management: t("screen.userManager"),
    monitoring: t("screen.monitoring"),
    "area-management": t("screen.areaManagement"),
    "data-import": t("screen.dataImport"),
    "hospital-directory": t("screen.hospitalDirectory"),
  };

  return (
    <PathWrapper>
      <CurrentScreen> {screenFake[patch.replace("/", "")]}</CurrentScreen>
      <SelectedLanguage overlay={menu} placement="bottomLeft">
        <Buttonanguage>
          {" "}
          <IConLanguage
            src={language === "vi" ? iconVietnam : iconUnitedStates}
            alt=""
          />{" "}
          {language}
        </Buttonanguage>
      </SelectedLanguage>
    </PathWrapper>
  );
}

export const HeaderScreen = ({ value, setValue }) => {
  const { t } = useTranslation();
  return (
    <div className="segmented">
      <Segmented
        options={[
          { label: t("dashBoard.obstetricDept"), value: EDepartment.OBSTETRIC },
          { label: t("dashBoard.pediatricDept"), value: EDepartment.PEDIATRIC },
        ]}
        value={value}
        onChange={setValue}
        size="large"
      />
    </div>
  );
};
